// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".configTable[data-v-6bff6c4b] {\n  width: 100%;\n}\n.configTable td[data-v-6bff6c4b] {\n  padding: 2px 0;\n}\n.configTable td[data-v-6bff6c4b]:first-child {\n  width: 95%;\n}\n.myBox[data-v-6bff6c4b] {\n  padding: 30px;\n  margin: 20px;\n  border: 2px solid black;\n  border-radius: 15px;\n  background-color: white;\n  overflow-x: hidden;\n  max-width: 95vw;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
